"use client";

import { useQuery } from "@tanstack/react-query";
import { getMeSession } from "@/lib/auth/storage";
import { meApi } from "@/lib/api/me";

export function useMeToday() {
  const session = getMeSession();
  return useQuery({
    queryKey: ["me", "today", session?.person_id],
    queryFn: () => meApi.getToday(session!),
    enabled: !!session,
    refetchInterval: 60_000,
  });
}

export function useMeHistory(month: string) {
  const session = getMeSession();
  return useQuery({
    queryKey: ["me", "history", session?.person_id, month],
    queryFn: () => meApi.getHistory(session!, month),
    enabled: !!session && !!month,
  });
}

export function useMeNotices() {
  const session = getMeSession();
  return useQuery({
    queryKey: ["me", "notices", session?.person_id],
    queryFn: () => meApi.listMyNotices(session!),
    enabled: !!session,
  });
}
